import { render, staticRenderFns } from "./TableAnggotaDetails.vue?vue&type=template&id=1a4db1bf&"
import script from "./TableAnggotaDetails.vue?vue&type=script&lang=js&"
export * from "./TableAnggotaDetails.vue?vue&type=script&lang=js&"
import style0 from "./TableAnggotaDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports